import { makeAutoObservable } from 'mobx';
import environment from '@environment';

export class AccountBannerStore {
  isBannerOpen = true;
  useMahLink = false;

  get bannerLink() {
    if (this.useMahLink) {
      return environment.ACCOUNT_TSANDCS_BANNER_MAH;
    } else {
      return environment.ACCOUNT_TSANDCS_BANNER;
    }
  }

  constructor() {
    makeAutoObservable(this);
  }

  closeBanner() {
    this.isBannerOpen = false;
  }

  initialize(useMah: boolean) {
    this.useMahLink = useMah;
  }
}